'use client'

import Button from '@eversports/klimt-primitives/alpha/Button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuPortal,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
  DropdownMenuRadioGroup,
} from '@eversports/klimt-primitives/alpha/DropdownMenu'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import { BRAND_SELECTED_CLOCK_ICON, CLOCK_ICON } from '../../../../../../../../App.icons'

import { START_TIME_OPTIONS } from './TimeFilter.constants'
import formatTimeFilter from './helpers/format-time-filter'
import { ALL_TIME_FILTERS_VALUE } from './TimeFilter'

interface Props {
  selectedTime: string | null
  updateFilter: (value: string) => void
}

const TimeFilterDropdown = ({ selectedTime, updateFilter }: Props) => {
  const t = useTranslations('discover-sport-city')
  const timeIcon = selectedTime ? BRAND_SELECTED_CLOCK_ICON : CLOCK_ICON
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild className="hidden items-center gap-1 sm:flex">
        <Button size="sm" variant={selectedTime ? 'tertiary-selected' : 'outline'}>
          <Image src={timeIcon} width={12} height={12} alt="" loading="lazy" />
          {selectedTime ? formatTimeFilter(selectedTime) : t('starting-time')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuPortal>
        <DropdownMenuContent align="start" className="h-28 overflow-y-scroll p-0">
          <DropdownMenuRadioGroup value={selectedTime ?? ALL_TIME_FILTERS_VALUE} onValueChange={updateFilter}>
            <DropdownMenuRadioItem variant="circular" value={ALL_TIME_FILTERS_VALUE}>
              {t('all-filters')}
            </DropdownMenuRadioItem>
            {START_TIME_OPTIONS.map((option) => (
              <DropdownMenuRadioItem key={option} variant="circular" value={option.toString()}>
                {formatTimeFilter(option.toString())}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  )
}

export default TimeFilterDropdown
